/** League visibility options — canonical values match lsc_leagues.visibility. */

export type LeagueVisibilityValue = 'private' | 'members' | 'public';

export interface LeagueVisibilityOption {
  value: LeagueVisibilityValue;
  label: string;
  description: string;
}

export const LEAGUE_VISIBILITY_OPTIONS: LeagueVisibilityOption[] = [
  {
    value: 'private',
    label: 'Private',
    description:
      'Only commissioners/admins can access setup and management areas. Best for setup or test leagues.',
  },
  {
    value: 'members',
    label: 'Members-only',
    description:
      'Approved league members can access the league workspace and archive. Recommended for beta leagues.',
  },
  {
    value: 'public',
    label: 'Public',
    description:
      'Future-facing public visibility for showcase/discovery features. Public discovery is not enabled yet.',
  },
];

export const PUBLIC_DISCOVERY_NOT_LIVE_COPY =
  'Public discovery is not enabled yet. This setting prepares future showcase features only.';

export function normalizeLeagueVisibility(value?: string | null): LeagueVisibilityValue {
  if (value === 'private' || value === 'public') return value;
  return 'members';
}

export function leagueVisibilityLabel(value?: string | null): string {
  const option = LEAGUE_VISIBILITY_OPTIONS.find(
    (opt) => opt.value === normalizeLeagueVisibility(value)
  );
  return option?.label ?? 'Members-only';
}
